module.exports = __webpack_public_path__ + "img/商务经理企业微信.26488e3f.png";